'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var TheirToggle = _interopDefault(require('react-toggle'));
require('react-toggle/style.css');
var Flexbox = _interopDefault(require('flexbox-react'));
var reactTransitionGroup = require('react-transition-group');
var ReactDOM = _interopDefault(require('react-dom'));
var ReactSVG = _interopDefault(require('react-svg'));
var React = require('react');
var React__default = _interopDefault(React);
var _ = require('lodash');
var ___default = _interopDefault(_);
var PropTypes = require('prop-types');
var PropTypes__default = _interopDefault(PropTypes);
var DropdownTreeSelect = _interopDefault(require('react-dropdown-tree-select'));



function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var graphicsVersion = '1.0.95';
var cdnUrl = "https://ncontracts-cdn.ncontracts.com";
var settings = {
  //todo: Figure out how to make cdn path come from root project
  cdnUrl: cdnUrl,
  cdnUrlGifs: "".concat(cdnUrl, "/").concat(graphicsVersion, "/gifs"),
  cdnUrlIcons: "".concat(cdnUrl, "/").concat(graphicsVersion, "/icons"),
  cdnUrlIllustrations: "".concat(cdnUrl, "/").concat(graphicsVersion, "/illustrations"),
  cdnUrlLoadingAnimations: "".concat(cdnUrl, "/").concat(graphicsVersion, "/loading-animations"),
  cdnUrlLogos: "".concat(cdnUrl, "/").concat(graphicsVersion, "/logos")
};

var AlertDialog = /*#__PURE__*/function (_Component) {
  _inherits(AlertDialog, _Component);

  var _super = _createSuper(AlertDialog);

  function AlertDialog() {
    _classCallCheck(this, AlertDialog);

    return _super.apply(this, arguments);
  }

  _createClass(AlertDialog, [{
    key: "render",
    value: function render() {
      var _this = this;

      var showCss = this.props.show === true ? "is-active" : "";
      var modalBackground = this.props.closeWhenClickElsewhere === true ? /*#__PURE__*/React__default.createElement("div", {
        className: "modal-background modal-background-container",
        onClick: this.props.onClose
      }) : /*#__PURE__*/React__default.createElement("div", {
        className: "modal-background modal-background-container"
      });
      var closeX = this.props.hasCloseButton ? /*#__PURE__*/React__default.createElement("img", {
        className: "close-modal-x is-pulled-right",
        src: settings.cdnUrl + "/x-white.svg",
        onClick: function onClick() {
          return _this.props.onClose();
        }
      }) : "";
      return /*#__PURE__*/React__default.createElement("div", {
        className: "modal ".concat(showCss)
      }, /*#__PURE__*/React__default.createElement("div", null, closeX, modalBackground, /*#__PURE__*/React__default.createElement("div", {
        className: "modal-content modal-content-container"
      }, this.props.children)));
    }
  }]);

  return AlertDialog;
}(React.Component);

AlertDialog.propTypes = {
  show: PropTypes__default.bool.isRequired,
  onClose: PropTypes__default.func,
  children: PropTypes__default.oneOfType([PropTypes__default.object, PropTypes__default.string]),
  closeWhenClickElsewhere: PropTypes__default.bool,
  hasCloseButton: PropTypes__default.bool
};
AlertDialog.defaultProps = {
  closeWhenClickElsewhere: true
};

var DefaultBtn = function DefaultBtn(_ref) {
  var className = _ref.className,
      onClick = _ref.onClick,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["className", "onClick", "disabled", "children"]);

  var cls = "btn--default ".concat(className || "", " ").concat(disabled ? "disabled" : "");
  return /*#__PURE__*/React__default.createElement("button", _extends({
    className: cls,
    onClick: onClick,
    disabled: disabled
  }, rest), children);
};

DefaultBtn.propTypes = {
  className: PropTypes__default.string,
  onClick: PropTypes__default.func.isRequired,
  disabled: PropTypes__default.bool,
  children: PropTypes__default.node
};

// @deprecated as of version: 1.15
// Date: ~05/17/19
// Replacement: Ncontracts.Common.UI => DefaultBtn.js
// Planned for removal once all implementations of DefaultButton
// have been removed across Ncontracts projects.

var DefaultButton = function DefaultButton(_ref) {
  var _ref$config = _ref.config,
      _ref$config$padding = _ref$config.padding,
      padding = _ref$config$padding === void 0 ? "13px" : _ref$config$padding,
      _ref$config$textAlign = _ref$config.textAlign,
      textAlign = _ref$config$textAlign === void 0 ? "center" : _ref$config$textAlign,
      _ref$config$textDecor = _ref$config.textDecoration,
      textDecoration = _ref$config$textDecor === void 0 ? "none" : _ref$config$textDecor,
      _ref$config$fontSize = _ref$config.fontSize,
      fontSize = _ref$config$fontSize === void 0 ? "14px" : _ref$config$fontSize,
      _ref$config$fontStyle = _ref$config.fontStyle,
      fontStyle = _ref$config$fontStyle === void 0 ? "normal" : _ref$config$fontStyle,
      _ref$config$fontWeigh = _ref$config.fontWeight,
      fontWeight = _ref$config$fontWeigh === void 0 ? "bold" : _ref$config$fontWeigh,
      _ref$config$textTrans = _ref$config.textTransform,
      textTransform = _ref$config$textTrans === void 0 ? "uppercase" : _ref$config$textTrans,
      _ref$config$display = _ref$config.display,
      display = _ref$config$display === void 0 ? "inline-block" : _ref$config$display,
      _ref$config$backgroun = _ref$config.backgroundColor,
      backgroundColor = _ref$config$backgroun === void 0 ? "white" : _ref$config$backgroun,
      _ref$config$border = _ref$config.border,
      border = _ref$config$border === void 0 ? "1px solid #bbbb" : _ref$config$border,
      _ref$config$borderRad = _ref$config.borderRadius,
      borderRadius = _ref$config$borderRad === void 0 ? "2px" : _ref$config$borderRad,
      _ref$config$boxShadow = _ref$config.boxShadow,
      boxShadow = _ref$config$boxShadow === void 0 ? "none" : _ref$config$boxShadow,
      _ref$config$color = _ref$config.color,
      color = _ref$config$color === void 0 ? "#1261ff" : _ref$config$color,
      marginLeft = _ref$config.marginLeft,
      marginRight = _ref$config.marginRight,
      marginBottom = _ref$config.marginBottom,
      marginTop = _ref$config.marginTop,
      className = _ref$config.className,
      clickEvent = _ref$config.clickEvent,
      buttonText = _ref$config.buttonText,
      _ref$config$disabled = _ref$config.disabled,
      disabled = _ref$config$disabled === void 0 ? false : _ref$config$disabled,
      width = _ref$config.width,
      _ref$config$cursor = _ref$config.cursor,
      cursor = _ref$config$cursor === void 0 ? "pointer" : _ref$config$cursor,
      _ref$config$letterSpa = _ref$config.letterSpacing,
      letterSpacing = _ref$config$letterSpa === void 0 ? "0.5px" : _ref$config$letterSpa,
      mode = _ref$config.mode;
  var modeStyle = getStyle(mode);

  var buttonStyle = _objectSpread2({}, {
    padding: padding,
    textAlign: textAlign,
    textDecoration: textDecoration,
    fontSize: fontSize,
    fontStyle: fontStyle,
    fontWeight: fontWeight,
    textTransform: textTransform,
    display: display,
    backgroundColor: backgroundColor,
    border: border,
    borderRadius: borderRadius,
    boxShadow: boxShadow,
    color: color,
    marginLeft: marginLeft,
    marginRight: marginRight,
    marginBottom: marginBottom,
    marginTop: marginTop,
    width: width,
    letterSpacing: letterSpacing,
    cursor: cursor
  }, {}, modeStyle);

  var disabledStyle = _objectSpread2({}, buttonStyle, {
    opacity: 0.5
  });

  var cls = "default-button ".concat(className || "");
  return /*#__PURE__*/React__default.createElement("button", {
    style: disabled ? disabledStyle : buttonStyle,
    className: cls,
    onClick: clickEvent,
    disabled: disabled
  }, buttonText);
};

var EditModeConfig = {
  backgroundColor: "white"
};
var SaveModeConfig = {
  backgroundColor: "#1261ff",
  border: "none",
  color: "white"
};
var DeleteModeConfig = {
  backgroundColor: "#d0021b",
  color: "white"
};
var CancelModeConfig = {
  boxShadow: "none",
  backgroundColor: "rgba(0,0,0,0)"
};
var DiscardModeConfig = {
  border: "none",
  boxShadow: "none",
  backgroundColor: "rgba(0,0,0,0)"
};
var DefaultButtonModes = ["EDIT", "SAVE", "DELETE", "CANCEL", "DISCARD"];

var getStyle = function getStyle(mode) {
  switch (mode) {
    case "EDIT":
      return EditModeConfig;

    case "SAVE":
      return SaveModeConfig;

    case "DELETE":
      return DeleteModeConfig;

    case "CANCEL":
      return CancelModeConfig;

    case "DISCARD":
      return DiscardModeConfig;

    default:
      return {};
  }
};

DefaultButton.propTypes = {
  config: PropTypes__default.shape({
    padding: PropTypes__default.string,
    textAlign: PropTypes__default.string,
    textDecoration: PropTypes__default.string,
    fontSize: PropTypes__default.string,
    fontStyle: PropTypes__default.string,
    fontWeight: PropTypes__default.string,
    textTransform: PropTypes__default.string,
    display: PropTypes__default.string,
    backgroundColor: PropTypes__default.string,
    border: PropTypes__default.string,
    borderRadius: PropTypes__default.string,
    boxShadow: PropTypes__default.string,
    color: PropTypes__default.string,
    marginLeft: PropTypes__default.string,
    marginRight: PropTypes__default.string,
    marginBottom: PropTypes__default.string,
    marginTop: PropTypes__default.string,
    className: PropTypes__default.string,
    clickEvent: PropTypes__default.func.isRequired,
    buttonText: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.object]).isRequired,
    disabled: PropTypes__default.bool,
    cursor: PropTypes__default.string,
    mode: PropTypes__default.oneOf(DefaultButtonModes)
  }).isRequired
};

var DefaultModal = /*#__PURE__*/function (_Component) {
  _inherits(DefaultModal, _Component);

  var _super = _createSuper(DefaultModal);

  function DefaultModal(props, context) {
    var _this;

    _classCallCheck(this, DefaultModal);

    _this = _super.call(this, props, context);
    _this.state = {
      showModal: false
    };
    return _this;
  }

  _createClass(DefaultModal, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var defaultModalStyle = {
        backgroundColor: "white",
        borderRadius: "5px",
        color: "black",
        padding: "15px"
      };
      return /*#__PURE__*/React__default.createElement("div", {
        className: "modal",
        style: {
          zIndex: 9999,
          display: this.props.isModalShowing ? "inline-flex" : "none"
        }
      }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("img", {
        className: "close-modal-x is-pulled-right",
        src: settings.cdnUrl + "/x-white.svg",
        onClick: function onClick() {
          return _this2.props.showModal(false);
        }
      }), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-background modal-background-container",
        onClick: function onClick() {
          return _this2.props.showModal(false);
        }
      }), /*#__PURE__*/React__default.createElement("div", {
        className: "modal-content modal-content-container"
      }, /*#__PURE__*/React__default.createElement("div", {
        style: this.props.modalStyle ? this.props.modalStyle : defaultModalStyle
      }, this.props.content))));
    }
  }]);

  return DefaultModal;
}(React.Component);

_defineProperty(DefaultModal, "propTypes", {
  showModal: PropTypes__default.func.isRequired,
  isModalShowing: PropTypes__default.bool.isRequired,
  content: PropTypes__default.oneOfType([PropTypes__default.object, PropTypes__default.array]).isRequired,
  modalStyle: PropTypes__default.object
});

var SmallLoader = function SmallLoader(props) {
  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: "small-loader"
  }, props), /*#__PURE__*/React__default.createElement("img", {
    src: settings.cdnUrl + "/small-loader.gif"
  }));
};

SmallLoader.propTypes = {};

var LoadingPanel = function LoadingPanel(_ref) {
  var _ref$config = _ref.config,
      _ref$config$active = _ref$config.active,
      active = _ref$config$active === void 0 ? false : _ref$config$active,
      _ref$config$message = _ref$config.message,
      message = _ref$config$message === void 0 ? "Loading ..." : _ref$config$message;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "loading-panel-overlay ".concat(active ? "" : "fadeOut")
  }, /*#__PURE__*/React__default.createElement("img", {
    alt: message,
    src: settings.cdnUrl + "/branded-loader.gif",
    className: "loading-logo"
  }));
};

LoadingPanel.propTypes = {
  config: PropTypes__default.shape({
    active: PropTypes__default.bool.isRequired,
    message: PropTypes__default.string
  }).isRequired
};

var measureWidth = function measureWidth(text) {
  var fontStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "normal";
  var fontWeight = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "14px";
  var fontFamily = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '"Open Sans", Arial, "Helvetica Neue", Helvetica, sans-serif';
  var canvas = document.createElement("canvas");
  var ctx = canvas.getContext("2d");
  ctx.font = "".concat(fontStyle, " ").concat(fontWeight, " ").concat(fontFamily);
  var mt = ctx.measureText(text);
  return mt.width;
};

var NumberInput = /*#__PURE__*/function (_Component) {
  _inherits(NumberInput, _Component);

  var _super = _createSuper(NumberInput);

  function NumberInput(props) {
    var _this;

    _classCallCheck(this, NumberInput);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "increment", function () {
      var _this$props = _this.props,
          step = _this$props.step,
          max = _this$props.max,
          precision = _this$props.precision;
      var next = parseFloat(Number(_this.state.value || 0) + step).toFixed(precision);
      var finalValue = parseFloat(next > max ? max : next);

      _this.changeValue(finalValue);

      _this.props.onChange({
        target: {
          value: finalValue,
          name: _this.props.name
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "decrement", function () {
      var _this$props2 = _this.props,
          step = _this$props2.step,
          min = _this$props2.min,
          precision = _this$props2.precision;
      var next = parseFloat(Number(_this.state.value || 0) - step).toFixed(precision);
      var finalValue = parseFloat(next < min ? min : next);

      _this.changeValue(finalValue);

      _this.props.onChange({
        target: {
          value: finalValue,
          name: _this.props.name
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", function (e) {
      _this.changeValue(e.target.value);
    });

    _defineProperty(_assertThisInitialized(_this), "changeValue", function (value) {
      _this.setState(_objectSpread2({}, _this.state, {
        value: value
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnBlur", function () {
      _this.clearFocus();

      if (!_this.props.onChange) {
        return;
      }

      var value = _this.state.value;
      var _this$props3 = _this.props,
          min = _this$props3.min,
          max = _this$props3.max,
          precision = _this$props3.precision;
      var num = Number(value);
      var finalValue = num;

      if (isNaN(parseFloat(value))) {
        finalValue = 0;
      } else if (parseFloat(value) < min) {
        finalValue = min;
      } else if (parseFloat(value) > max) {
        finalValue = max;
      } else {
        finalValue = parseFloat(parseFloat(value).toFixed(precision));
      }

      _this.setState(_objectSpread2({}, _this.state, {
        value: finalValue
      }));

      _this.props.onChange({
        target: {
          value: finalValue,
          name: _this.props.name
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "computeWidthForInput", function () {
      var value = _this.state.value;

      if (value === null || value === undefined) {
        return "0";
      }

      var width = measureWidth(value.toString(), undefined,
      /*fontWeight*/
      "16px");
      var arrowWidth = 18;
      var padding = 5;
      return "".concat(width + arrowWidth + padding, "px");
    });

    _defineProperty(_assertThisInitialized(_this), "setFocus", function () {
      _this.setState(_objectSpread2({}, _this.state, {
        focus: true
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "clearFocus", function () {
      _this.setState(_objectSpread2({}, _this.state, {
        focus: false
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "keyPress", function (e) {
      switch (e.key) {
        case "ArrowUp":
          _this.increment();

          break;

        case "ArrowDown":
          _this.decrement();

          break;

        default:
          break;
      }
    });

    _this.state = {
      value: props.value,
      focus: false
    };
    return _this;
  }

  _createClass(NumberInput, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, prevContext) {
      if (prevProps.value !== this.props.value) {
        this.setState(_objectSpread2({}, this.state, {
          value: this.props.value
        }));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var width = this.computeWidthForInput();
      var _this$state = this.state,
          focus = _this$state.focus,
          value = _this$state.value;
      var focusClass = focus ? "focus" : "";
      var _this$props4 = this.props,
          name = _this$props4.name,
          maxLength = _this$props4.maxLength,
          className = _this$props4.className;
      var onChange = this.onChange,
          keyPress = this.keyPress,
          setFocus = this.setFocus,
          increment = this.increment,
          decrement = this.decrement,
          handleOnBlur = this.handleOnBlur;
      var upArrow = settings.cdnUrl + "/caret-up-grey.svg";
      var downArrow = settings.cdnUrl + "/caret-down-grey.svg";
      return /*#__PURE__*/React__default.createElement("div", {
        className: "number-input ".concat(className, " ").concat(focusClass)
      }, /*#__PURE__*/React__default.createElement("input", {
        style: {
          width: width
        },
        value: value,
        onChange: onChange,
        name: name,
        onKeyDown: keyPress,
        onFocus: setFocus,
        onBlur: handleOnBlur,
        maxLength: maxLength
      }), /*#__PURE__*/React__default.createElement("span", {
        className: "increment number-arrow",
        onClick: increment
      }, /*#__PURE__*/React__default.createElement("img", {
        src: upArrow,
        alt: "up"
      })), /*#__PURE__*/React__default.createElement("span", {
        className: "decrement number-arrow",
        onClick: decrement
      }, /*#__PURE__*/React__default.createElement("img", {
        src: downArrow,
        alt: "down"
      })));
    }
  }]);

  return NumberInput;
}(React.Component);

_defineProperty(NumberInput, "propTypes", {
  value: PropTypes__default.number,
  name: PropTypes__default.string,
  //this is the name that will be passed on to the onChange func
  onChange: PropTypes__default.func,
  //onChange will be called with a single parameter having a shape of { target: { value, name } }
  className: PropTypes__default.string,
  min: PropTypes__default.number,
  max: PropTypes__default.number,
  maxLength: PropTypes__default.number,
  precision: PropTypes__default.number,
  step: PropTypes__default.number
});

_defineProperty(NumberInput, "defaultProps", {
  min: 0,
  max: 100,
  maxLength: 4,
  precision: 0,
  step: 1
});

var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var classnames = createCommonjsModule(function (module) {
/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
}());
});

function isNullOrUndefined(value) {
  if (value === undefined || value === null) return true;
}

function isEmpty(value) {
  if (isNullOrUndefined(value)) return true;
  if (typeof value === "string") return value.trim().length === 0;
  if (Array.isArray(value)) return value.length === 0;
  return false;
}

var SearchInput = /*#__PURE__*/function (_Component) {
  _inherits(SearchInput, _Component);

  var _super = _createSuper(SearchInput);

  function SearchInput(props) {
    var _this;

    _classCallCheck(this, SearchInput);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleInputChange", function (e) {
      var newValue = e.target.value;
      var delay = _this.props.delay;

      _this.updateState(newValue);

      clearTimeout(_this.timeout);

      if (delay != null && delay > 0) {
        _this.timeout = setTimeout(function () {
          _this.changeValue(newValue);
        }, delay);
      } else {
        _this.changeValue(newValue);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "updateState", function (newValue) {
      _this.setState(_objectSpread2({}, _this.state, {
        isOpen: _this.props.alwaysOpen ? true : !_this.isEmpty(newValue),
        searchValue: newValue
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "clearInput", function () {
      clearTimeout(_this.timeout);

      _this.setState(_objectSpread2({}, _this.state, {
        searchValue: ""
      }));

      _this.changeValue("");
    });

    _defineProperty(_assertThisInitialized(_this), "changeValue", function (newValue) {
      _this.props.onValueChange(newValue);
    });

    _defineProperty(_assertThisInitialized(_this), "isEmpty", function (value) {
      return value === "" || value === undefined || value === null;
    });

    _defineProperty(_assertThisInitialized(_this), "setFocusOn", function () {
      _this.setState(_objectSpread2({}, _this.state, {
        hasFocus: true
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "setFocusOut", function () {
      if (_this.props.alwaysOpen) {
        _this.setState(_objectSpread2({}, _this.state, {
          hasFocus: false
        }));
      } else {
        _this.setState(_objectSpread2({}, _this.state, {
          hasFocus: false,
          isOpen: !_this.isEmpty(_this.state.searchValue)
        }));
      }
    });

    _this.state = {
      isOpen: _this.props.alwaysOpen,
      hasFocus: isEmpty(_this.props.initialValue) ? false : true,
      searchValue: isEmpty(_this.props.initialValue) ? "" : _this.props.initialValue
    };
    _this.timeout = undefined;
    return _this;
  }

  _createClass(SearchInput, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          placeholder = _this$props.placeholder,
          className = _this$props.className,
          _this$props$tooltipTe = _this$props.tooltipText,
          tooltipText = _this$props$tooltipTe === void 0 ? "search" : _this$props$tooltipTe,
          onValueChange = _this$props.onValueChange,
          alwaysOpen = _this$props.alwaysOpen,
          delay = _this$props.delay,
          rest = _objectWithoutProperties(_this$props, ["placeholder", "className", "tooltipText", "onValueChange", "alwaysOpen", "delay"]);

      var _this$state = this.state,
          isOpen = _this$state.isOpen,
          searchValue = _this$state.searchValue,
          hasFocus = _this$state.hasFocus;
      return /*#__PURE__*/React__default.createElement("div", _extends({
        className: classnames("control search has-icons-left has-icons-right", className, {
          open: isOpen || hasFocus,
          rightToLeft: this.props.isRightToLeft === true
        })
      }, rest), /*#__PURE__*/React__default.createElement("div", {
        "data-tooltip": tooltipText,
        className: hasFocus === true ? "" : "tooltip is-tooltip-bottom"
      }, /*#__PURE__*/React__default.createElement("input", {
        className: classnames("input search-input fontAwesome", {
          open: isOpen || hasFocus
        }),
        type: "text",
        placeholder: hasFocus === true || alwaysOpen === true ? placeholder : "",
        onChange: this.handleInputChange,
        value: searchValue,
        onFocus: this.setFocusOn,
        onBlur: this.setFocusOut
      }), /*#__PURE__*/React__default.createElement("span", {
        className: "icon is-small is-left"
      }, /*#__PURE__*/React__default.createElement("img", {
        className: "search-icon",
        src: "".concat(settings.cdnUrlIcons, "/search.svg")
      })), /*#__PURE__*/React__default.createElement("span", {
        className: "clear-search icon is-small"
      }, searchValue !== "" ? /*#__PURE__*/React__default.createElement("div", {
        className: "clear",
        onClick: this.clearInput
      }, /*#__PURE__*/React__default.createElement(ReactSVG, {
        src: "".concat(settings.cdnUrlIcons, "/x-red.svg")
      })) : "")));
    }
  }]);

  return SearchInput;
}(React.Component);

_defineProperty(SearchInput, "propTypes", {
  initialValue: PropTypes__default.string,
  alwaysOpen: PropTypes__default.bool,
  placeholder: PropTypes__default.string,
  onValueChange: PropTypes__default.func,
  className: PropTypes__default.string,
  tooltipText: PropTypes__default.string,
  delay: PropTypes__default.number,
  isRightToLeft: PropTypes__default.bool
});

_defineProperty(SearchInput, "defaultProps", {
  delay: 0,
  isRightToLeft: false
});

var ShowMore = /*#__PURE__*/function (_Component) {
  _inherits(ShowMore, _Component);

  var _super = _createSuper(ShowMore);

  function ShowMore(props, context) {
    var _this;

    _classCallCheck(this, ShowMore);

    _this = _super.call(this, props, context);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.setState(_objectSpread2({}, _this.state, {
        shouldShow: _this.textDiv.clientHeight > _this.props.maxHeight
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "toggle", function () {
      _this.setState(_objectSpread2({}, _this.state, {
        showMore: !_this.state.showMore
      }));
    });

    _this.state = {
      shouldShow: false,
      showMore: true
    };
    return _this;
  }

  _createClass(ShowMore, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      if (this.state.shouldShow === true) {
        var style = this.state.showMore === true ? {
          maxHeight: this.props.maxHeight,
          overflow: this.state.showMore === true ? "" : "hidden"
        } : {};
        var cssName = this.state.showMore === true ? "show-more-div-gradient" : "";
        var showMoreText = this.state.showMore === true ? /*#__PURE__*/React__default.createElement("span", null, "show more ", /*#__PURE__*/React__default.createElement("i", {
          className: "fa fa-angle-down"
        })) : /*#__PURE__*/React__default.createElement("span", null, "show less ", /*#__PURE__*/React__default.createElement("i", {
          className: "fa fa-angle-up"
        }));
        return /*#__PURE__*/React__default.createElement("div", {
          className: "show-more"
        }, /*#__PURE__*/React__default.createElement("p", {
          style: style,
          className: cssName,
          ref: function ref(me) {
            return _this2.textDiv = me;
          }
        }, this.props.text), /*#__PURE__*/React__default.createElement("div", {
          onClick: this.toggle,
          className: "show-more-link"
        }, showMoreText));
      } else {
        return /*#__PURE__*/React__default.createElement("div", {
          className: "show-more"
        }, /*#__PURE__*/React__default.createElement("p", {
          ref: function ref(me) {
            return _this2.textDiv = me;
          }
        }, this.props.text));
      }
    }
  }]);

  return ShowMore;
}(React.Component);

_defineProperty(ShowMore, "propTypes", {
  text: PropTypes__default.oneOfType([PropTypes__default.object, PropTypes__default.string, PropTypes__default.node, PropTypes__default.element]).isRequired,
  maxHeight: PropTypes__default.number
});

_defineProperty(ShowMore, "defaultProps", {
  maxHeight: 150
});

var TableActionBar = /*#__PURE__*/function (_Component) {
  _inherits(TableActionBar, _Component);

  var _super = _createSuper(TableActionBar);

  function TableActionBar() {
    _classCallCheck(this, TableActionBar);

    return _super.apply(this, arguments);
  }

  _createClass(TableActionBar, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React__default.createElement("div", {
        className: "level list-actions-bar is-mobile"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "level-left"
      }), /*#__PURE__*/React__default.createElement("div", {
        className: "level-right"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "level-item",
        title: "Not implemented"
      }, /*#__PURE__*/React__default.createElement("a", {
        className: "button svg-button-rounded"
      }, /*#__PURE__*/React__default.createElement(ReactSVG, {
        src: settings.cdnUrl + "/filter-nocircle.svg",
        className: "injected icon filter-icon"
      }))), /*#__PURE__*/React__default.createElement("div", {
        className: "level-item",
        title: "Not implemented"
      }, /*#__PURE__*/React__default.createElement("img", {
        src: settings.cdnUrl + "/download.svg",
        className: "download-icon icon"
      }))));
    }
  }]);

  return TableActionBar;
}(React.Component);

var downArrow = settings.cdnUrl + "/caret-down-grey.svg";

var Dropdown = /*#__PURE__*/function (_Component) {
  _inherits(Dropdown, _Component);

  var _super = _createSuper(Dropdown);

  function Dropdown(props) {
    var _this;

    _classCallCheck(this, Dropdown);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleDocumentClick", function (event) {
      if (_this.mounted) {
        if (!ReactDOM.findDOMNode(_assertThisInitialized(_this)).contains(event.target)) {
          if (_this.state.isOpen) {
            _this.setState({
              isOpen: false
            });
          }
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "toggleOptions", function () {
      var inverse = !_this.state.isOpen;

      _this.setState(_objectSpread2({}, _this.state, {
        isOpen: inverse
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "selectOption", function (option) {
      _this.toggleOptions();

      var onOptionSelected = _this.props.onOptionSelected;

      if (onOptionSelected === undefined) {
        return;
      }

      onOptionSelected(option);
    });

    _defineProperty(_assertThisInitialized(_this), "renderOptions", function () {
      var isOpen = _this.state.isOpen;
      var options = _this.props.options;

      if (!isOpen) {
        return null;
      }

      return /*#__PURE__*/React__default.createElement("div", {
        className: "dropdown-option-list"
      }, options.map(function (item) {
        return /*#__PURE__*/React__default.createElement("div", {
          className: "dropdown-option-item",
          key: item.key,
          onClick: function onClick() {
            return _this.selectOption(item);
          }
        }, item.value);
      }));
    });

    _this.state = {
      isOpen: false
    };
    return _this;
  }

  _createClass(Dropdown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
      document.addEventListener("click", this.handleDocumentClick, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
      document.removeEventListener("click", this.handleDocumentClick, false);
    }
  }, {
    key: "render",
    value: function render() {
      var widths = this.props.options.map(function (x) {
        return measureWidth(x.value);
      });
      var longest = Math.max.apply(Math, _toConsumableArray(widths));
      var width = getFullWidth(longest);
      return /*#__PURE__*/React__default.createElement("div", {
        className: "dropdown dropdown-style ".concat(this.props.className),
        onClick: this.toggleOptions,
        style: {
          width: width
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "dropdown-selected"
      }, this.props.value), this.renderOptions(), /*#__PURE__*/React__default.createElement("span", {
        className: "dropdown-arrow"
      }, /*#__PURE__*/React__default.createElement("img", {
        src: downArrow,
        alt: "down"
      })));
    }
  }]);

  return Dropdown;
}(React.Component);

_defineProperty(Dropdown, "propTypes", {
  className: PropTypes__default.string,
  options: PropTypes__default.arrayOf(PropTypes__default.shape({
    key: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.number]),
    value: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.number]).isRequired
  })).isRequired,
  value: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.number]),
  onOptionSelected: PropTypes__default.func
});

var getFullWidth = function getFullWidth(textWidth) {
  var arrowWidth = 18;
  var padding = 5;
  return "".concat(textWidth + arrowWidth + padding, "px");
};

var DefaultPageSize = 10;
var PageSizes = [5, 10, 25, 50, 100];

var TablePaginationBar = /*#__PURE__*/function (_Component) {
  _inherits(TablePaginationBar, _Component);

  var _super = _createSuper(TablePaginationBar);

  function TablePaginationBar() {
    var _this;

    _classCallCheck(this, TablePaginationBar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "goToPage", function (page) {
      if (_this.props.onPageChange) {
        _this.props.onPageChange(page);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "incrementPage", function (max) {
      _this.goToPage(Math.min(max, _this.props.page + 1));
    });

    _defineProperty(_assertThisInitialized(_this), "decrementPage", function () {
      _this.goToPage(Math.max(1, _this.props.page - 1));
    });

    _defineProperty(_assertThisInitialized(_this), "onPageSizeChange", function (option) {
      if (_this.props.onPageSizeChange === undefined || _this.props.onPageSizeChange === null) {
        return;
      }

      _this.props.onPageSizeChange(Number(option.value));
    });

    return _this;
  }

  _createClass(TablePaginationBar, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          page = _this$props.page,
          pageSize = _this$props.pageSize,
          totalItems = _this$props.totalItems;
      page = restrictPageToLimits(pageSize, totalItems, page);
      pageSize = pageSize || DefaultPageSize;

      var totalPages = Math.ceil(totalItems / pageSize),
          index = page - 1,
          pageStart = index * pageSize + 1,
          pageEnd = Math.min(totalItems, pageStart + pageSize - 1),
          pages = ___default.range(1, totalPages + 1);

      var increment = function increment() {
        return _this2.incrementPage(___default.last(pages));
      };

      var pageSizeOptions = PageSizes.map(function (x) {
        return {
          key: x,
          value: x
        };
      });
      var disableDecrement = page === 1;
      var disableIncrement = page === totalPages;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "level is-mobile paging"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "level-left"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "level-item"
      }, /*#__PURE__*/React__default.createElement("a", {
        className: "button svg-button-rounded",
        alt: "previous",
        disabled: disableDecrement,
        onClick: this.decrementPage
      }, /*#__PURE__*/React__default.createElement(ReactSVG, {
        src: settings.cdnUrl + "/arrow-prev.svg",
        className: "injected icon"
      })), /*#__PURE__*/React__default.createElement("a", {
        className: "button svg-button-rounded",
        alt: "next",
        disabled: disableIncrement,
        onClick: increment
      }, /*#__PURE__*/React__default.createElement(ReactSVG, {
        src: settings.cdnUrl + "/arrow-next.svg",
        className: "injected icon"
      }))), /*#__PURE__*/React__default.createElement("div", {
        className: "level-item"
      }, /*#__PURE__*/React__default.createElement("p", {
        className: "level-item paging-item-count"
      }, "Showing ".concat(pageStart, " - ").concat(pageEnd, " of ").concat(totalItems, " items")))), /*#__PURE__*/React__default.createElement("div", {
        className: "level-right"
      }, /*#__PURE__*/React__default.createElement(Dropdown, {
        value: pageSize,
        onOptionSelected: this.onPageSizeChange,
        options: pageSizeOptions,
        className: "items-per-page-dropdown"
      }), "items per page"));
    }
  }]);

  return TablePaginationBar;
}(React.Component);

_defineProperty(TablePaginationBar, "propTypes", {
  pageSize: PropTypes__default.number,
  totalItems: PropTypes__default.number.isRequired,
  onPageChange: PropTypes__default.func,
  onPageSizeChange: PropTypes__default.func,
  page: PropTypes__default.number.isRequired
});

var restrictPageToLimits = function restrictPageToLimits(pageSize, total, page) {
  return Math.max(Math.min(Math.ceil(total / pageSize), page || 1), 1);
};

var SidePanel = /*#__PURE__*/function (_Component) {
  _inherits(SidePanel, _Component);

  var _super = _createSuper(SidePanel);

  function SidePanel() {
    _classCallCheck(this, SidePanel);

    return _super.apply(this, arguments);
  }

  _createClass(SidePanel, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        className: "side-panel-overlay",
        style: this.props.isSidePanelShowing ? {
          display: "inline-flex"
        } : {
          display: "none"
        }
      }), /*#__PURE__*/React__default.createElement("div", {
        className: "side-panel",
        style: this.props.isSidePanelShowing ? {
          display: "inline-flex"
        } : {
          display: "none"
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "side-panel-content"
      }, this.props.content)));
    }
  }]);

  return SidePanel;
}(React.Component);

_defineProperty(SidePanel, "propTypes", {
  isSidePanelShowing: PropTypes__default.bool.isRequired,
  content: PropTypes__default.oneOfType([PropTypes__default.object, PropTypes__default.array]).isRequired
});

var ValidatedField = /*#__PURE__*/function (_Component) {
  _inherits(ValidatedField, _Component);

  var _super = _createSuper(ValidatedField);

  function ValidatedField() {
    var _this;

    _classCallCheck(this, ValidatedField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "renderMessage", function () {
      var _this$props = _this.props,
          isValid = _this$props.isValid,
          validationMessage = _this$props.validationMessage;
      return isValid ? null : /*#__PURE__*/React__default.createElement("div", {
        className: "validated-field-message"
      }, " ", validationMessage);
    });

    return _this;
  }

  _createClass(ValidatedField, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React__default.createElement("div", {
        className: "validated-field ".concat(this.props.isValid ? "" : "invalid")
      }, this.props.children, this.renderMessage());
    }
  }]);

  return ValidatedField;
}(React.Component);

_defineProperty(ValidatedField, "propTypes", {
  validationMessage: PropTypes__default.string,
  isValid: PropTypes__default.bool.isRequired,
  children: PropTypes__default.oneOfType([PropTypes__default.arrayOf(PropTypes__default.node), PropTypes__default.node]).isRequired
});

var RequiredInput = /*#__PURE__*/function (_Component) {
  _inherits(RequiredInput, _Component);

  var _super = _createSuper(RequiredInput);

  function RequiredInput() {
    var _this;

    _classCallCheck(this, RequiredInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "isValid", function () {
      var _this$props = _this.props,
          shouldValidate = _this$props.shouldValidate,
          isValid = _this$props.isValid;

      if (!shouldValidate) {
        return true;
      }

      return isValid;
    });

    return _this;
  }

  _createClass(RequiredInput, [{
    key: "render",
    value: function render() {
      var message = !isEmpty(this.props.validationMessage) ? this.props.validationMessage : "Please enter ".concat(this.props.label);
      return /*#__PURE__*/React__default.createElement(ValidatedField, {
        isValid: this.isValid(),
        validationMessage: message
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "label"
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "required-label"
      }, "*"), this.props.label), this.props.children);
    }
  }]);

  return RequiredInput;
}(React.Component);

_defineProperty(RequiredInput, "propTypes", {
  label: PropTypes__default.string,
  validationMessage: PropTypes__default.string,
  shouldValidate: PropTypes__default.bool,
  isValid: PropTypes__default.bool.isRequired,
  children: PropTypes__default.oneOfType([PropTypes__default.arrayOf(PropTypes__default.node), PropTypes__default.node]).isRequired
});

_defineProperty(RequiredInput, "defaultProps", {
  shouldValidate: false
});

var Toggle = /*#__PURE__*/function (_Component) {
  _inherits(Toggle, _Component);

  var _super = _createSuper(Toggle);

  function Toggle() {
    _classCallCheck(this, Toggle);

    return _super.apply(this, arguments);
  }

  _createClass(Toggle, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onChange = _this$props.onChange,
          defaultChecked = _this$props.defaultChecked,
          icons = _this$props.icons;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "toggle"
      }, /*#__PURE__*/React__default.createElement(TheirToggle, {
        onChange: onChange,
        icons: icons,
        defaultChecked: defaultChecked,
        checked: defaultChecked
      }));
    }
  }]);

  return Toggle;
}(React.Component);

_defineProperty(Toggle, "propTypes", {
  onChange: PropTypes__default.func.isRequired,
  defaultChecked: PropTypes__default.bool,
  icons: PropTypes__default.oneOfType([PropTypes__default.bool, PropTypes__default.shape({
    checked: PropTypes__default.node,
    unchecked: PropTypes__default.node
  })])
});

var Accordion = /*#__PURE__*/function (_React$Component) {
  _inherits(Accordion, _React$Component);

  var _super = _createSuper(Accordion);

  function Accordion(props, context) {
    _classCallCheck(this, Accordion);

    return _super.call(this, props, context);
  }

  _createClass(Accordion, [{
    key: "render",
    value: function render() {
      var isOpen = this.props.showAccordion;
      var showArrow = this.props.showAccordionToggle;
      var showItemCount = this.props.itemCount !== undefined;
      var headerHasIcon = this.props.headerIcon !== undefined;
      var containerClassName = "accordion-container ".concat(isOpen ? 'accordion--open' : '', " ").concat(headerHasIcon ? 'accordion--tall' : 'accordion--short', " ").concat(this.props.className);
      var contentClassname = "accordion-content ".concat(isOpen ? 'accordion--open' : '');
      return /*#__PURE__*/React__default.createElement("div", {
        className: containerClassName
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "accordion-toggle",
        onClick: this.props.toggleAccordion
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "accordion-header level is-mobile"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "level-left"
      }, headerHasIcon && /*#__PURE__*/React__default.createElement("div", {
        className: "accordion-header--icon"
      }, this.props.headerIcon), this.props.headerLeft, showItemCount && /*#__PURE__*/React__default.createElement("span", {
        className: "accordion-item-count"
      }, this.props.itemCount)), /*#__PURE__*/React__default.createElement("div", {
        className: "level-right"
      }, this.props.headerRight, showArrow && /*#__PURE__*/React__default.createElement("i", {
        className: "expand-collapse-icon fa fa-chevron-down"
      })))), /*#__PURE__*/React__default.createElement("div", {
        className: "accordion-divider"
      }), /*#__PURE__*/React__default.createElement("div", {
        className: contentClassname
      }, this.props.content));
    }
  }]);

  return Accordion;
}(React__default.Component);

_defineProperty(Accordion, "propTypes", {
  headerLeft: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
  headerRight: PropTypes.object,
  content: PropTypes.object.isRequired,
  toggleAccordion: PropTypes.func.isRequired,
  showAccordion: PropTypes.bool.isRequired,
  showAccordionToggle: PropTypes.bool,
  itemCount: PropTypes.number,
  headerIcon: PropTypes.object,
  className: PropTypes.oneOfType([PropTypes.object, PropTypes.string])
});

_defineProperty(Accordion, "defaultProps", {
  showAccordionToggle: true
});

var TabModel = {
  name: PropTypes__default.string.isRequired,
  tabClickedHandler: PropTypes__default.func,
  content: PropTypes__default.node.isRequired
};

var Tab = function Tab(_ref) {
  var tabModel = _ref.tabModel,
      isActive = _ref.isActive,
      changeActiveTab = _ref.changeActiveTab;

  var handleClicked = function handleClicked() {
    if (tabModel.tabClickedHandler !== undefined) {
      tabModel.tabClickedHandler();
    }

    changeActiveTab(tabModel);
  };

  return /*#__PURE__*/React__default.createElement("li", {
    className: isActive ? "is-active" : "",
    onClick: handleClicked
  }, /*#__PURE__*/React__default.createElement("a", null, /*#__PURE__*/React__default.createElement("span", null, tabModel.name)));
};

Tab.propTypes = {
  tabModel: PropTypes__default.shape(TabModel).isRequired,
  changeActiveTab: PropTypes__default.func.isRequired,
  isActive: PropTypes__default.bool.isRequired
};

var TabbedPage = function TabbedPage(_ref) {
  var tabModels = _ref.tabModels,
      initialActiveTab = _ref.initialActiveTab,
      classes = _ref.classes,
      rest = _objectWithoutProperties(_ref, ["tabModels", "initialActiveTab", "classes"]);

  var _useState = React.useState(),
      _useState2 = _slicedToArray(_useState, 2),
      activeTab = _useState2[0],
      setActiveTab = _useState2[1];

  React.useEffect(function () {
    setActiveTab(initialActiveTab);
  }, [initialActiveTab]);
  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: classnames("tabbed-page", classes)
  }, rest), /*#__PURE__*/React__default.createElement("div", {
    className: "tabbed-page--tabs tabs is-boxed is-marginless"
  }, /*#__PURE__*/React__default.createElement("ul", {
    className: "tab-container"
  }, tabModels.map(function (tab, index) {
    return /*#__PURE__*/React__default.createElement(Tab, {
      tabModel: tab,
      key: index,
      changeActiveTab: function changeActiveTab(newActiveTab) {
        return setActiveTab(newActiveTab);
      },
      isActive: activeTab === tab
    });
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "tabbed-page--content"
  }, activeTab !== undefined ? activeTab.content : /*#__PURE__*/React__default.createElement(React__default.Fragment, null)));
};

TabbedPage.propTypes = {
  tabModels: PropTypes__default.arrayOf(PropTypes__default.shape(TabModel)).isRequired,
  initialActiveTab: PropTypes__default.shape(TabModel),
  classes: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.arrayOf(PropTypes__default.string), PropTypes__default.object])
};

var RadioInput = /*#__PURE__*/function (_Component) {
  _inherits(RadioInput, _Component);

  var _super = _createSuper(RadioInput);

  function RadioInput(props) {
    var _this;

    _classCallCheck(this, RadioInput);

    _this = _super.call(this, props);
    _this.inputRef = React__default.createRef();
    return _this;
  }

  _createClass(RadioInput, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          id = _this$props.id,
          name = _this$props.name,
          value = _this$props.value,
          checked = _this$props.checked,
          _onChange = _this$props.onChange,
          children = _this$props.children,
          className = _this$props.className,
          rest = _objectWithoutProperties(_this$props, ["id", "name", "value", "checked", "onChange", "children", "className"]);

      var finalClass = "radio-input-container ".concat(className || '');
      var background = "url(\"".concat(settings.cdnUrlIcons, "/radio-").concat(checked ? 'selected' : 'unselected', ".svg\")");
      return /*#__PURE__*/React__default.createElement("div", _extends({
        className: finalClass,
        onClick: function onClick() {
          return _this2.inputRef.current.click();
        }
      }, rest), /*#__PURE__*/React__default.createElement("input", {
        type: "radio",
        id: id,
        name: name,
        value: value,
        checked: checked,
        onChange: function onChange(event) {
          return !_onChange ? null : _onChange(event);
        },
        ref: this.inputRef
      }), /*#__PURE__*/React__default.createElement("label", {
        htmlFor: id
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "radio-input-background",
        style: {
          background: background
        }
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "radio-input-background-child"
      })), /*#__PURE__*/React__default.createElement("span", {
        className: "radio-input-child-content ".concat(checked ? 'checked' : 'unchecked')
      }, children)));
    }
  }]);

  return RadioInput;
}(React.Component);

_defineProperty(RadioInput, "propTypes", {
  id: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.number]),
  name: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.number]),
  value: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.number]),
  checked: PropTypes__default.bool,
  onChange: PropTypes__default.func,
  children: PropTypes__default.node,
  className: PropTypes__default.string
});

var EmptyState = /*#__PURE__*/function (_Component) {
  _inherits(EmptyState, _Component);

  var _super = _createSuper(EmptyState);

  function EmptyState() {
    _classCallCheck(this, EmptyState);

    return _super.apply(this, arguments);
  }

  _createClass(EmptyState, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          imageSrc = _this$props.imageSrc,
          imageAlt = _this$props.imageAlt,
          message = _this$props.message,
          button = _this$props.button,
          classes = _this$props.classes;
      return /*#__PURE__*/React__default.createElement(Flexbox, {
        className: classnames("empty-state", classes),
        flexDirection: "column",
        alignItems: "center"
      }, imageSrc !== undefined ? /*#__PURE__*/React__default.createElement("img", {
        className: "empty-state-image",
        alt: imageAlt,
        src: imageSrc
      }) : "", /*#__PURE__*/React__default.createElement("div", {
        className: "empty-state-message"
      }, message), /*#__PURE__*/React__default.createElement("div", {
        className: "empty-state-button"
      }, button));
    }
  }]);

  return EmptyState;
}(React.Component);

_defineProperty(EmptyState, "propTypes", {
  imageSrc: PropTypes__default.string,
  imageAlt: PropTypes__default.string,
  message: PropTypes__default.node,
  button: PropTypes__default.node,
  classes: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.array, PropTypes__default.object])
});

var CircleButton = /*#__PURE__*/function (_Component) {
  _inherits(CircleButton, _Component);

  var _super = _createSuper(CircleButton);

  function CircleButton() {
    _classCallCheck(this, CircleButton);

    return _super.apply(this, arguments);
  }

  _createClass(CircleButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          isOpen = _this$props.isOpen,
          children = _this$props.children,
          rest = _objectWithoutProperties(_this$props, ["className", "isOpen", "children"]);

      var fullClassName = "circle-button ".concat(isOpen ? 'open' : '', " ").concat(className || '');
      return /*#__PURE__*/React__default.createElement("div", _extends({
        className: fullClassName
      }, rest), children);
    }
  }]);

  return CircleButton;
}(React.Component);

var autosize = createCommonjsModule(function (module, exports) {
/*!
	autosize 4.0.2
	license: MIT
	http://www.jacklmoore.com/autosize
*/
(function (global, factory) {
	{
		factory(module, exports);
	}
})(commonjsGlobal, function (module, exports) {

	var map = typeof Map === "function" ? new Map() : function () {
		var keys = [];
		var values = [];

		return {
			has: function has(key) {
				return keys.indexOf(key) > -1;
			},
			get: function get(key) {
				return values[keys.indexOf(key)];
			},
			set: function set(key, value) {
				if (keys.indexOf(key) === -1) {
					keys.push(key);
					values.push(value);
				}
			},
			delete: function _delete(key) {
				var index = keys.indexOf(key);
				if (index > -1) {
					keys.splice(index, 1);
					values.splice(index, 1);
				}
			}
		};
	}();

	var createEvent = function createEvent(name) {
		return new Event(name, { bubbles: true });
	};
	try {
		new Event('test');
	} catch (e) {
		// IE does not support `new Event()`
		createEvent = function createEvent(name) {
			var evt = document.createEvent('Event');
			evt.initEvent(name, true, false);
			return evt;
		};
	}

	function assign(ta) {
		if (!ta || !ta.nodeName || ta.nodeName !== 'TEXTAREA' || map.has(ta)) return;

		var heightOffset = null;
		var clientWidth = null;
		var cachedHeight = null;

		function init() {
			var style = window.getComputedStyle(ta, null);

			if (style.resize === 'vertical') {
				ta.style.resize = 'none';
			} else if (style.resize === 'both') {
				ta.style.resize = 'horizontal';
			}

			if (style.boxSizing === 'content-box') {
				heightOffset = -(parseFloat(style.paddingTop) + parseFloat(style.paddingBottom));
			} else {
				heightOffset = parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
			}
			// Fix when a textarea is not on document body and heightOffset is Not a Number
			if (isNaN(heightOffset)) {
				heightOffset = 0;
			}

			update();
		}

		function changeOverflow(value) {
			{
				// Chrome/Safari-specific fix:
				// When the textarea y-overflow is hidden, Chrome/Safari do not reflow the text to account for the space
				// made available by removing the scrollbar. The following forces the necessary text reflow.
				var width = ta.style.width;
				ta.style.width = '0px';
				// Force reflow:
				/* jshint ignore:start */
				ta.offsetWidth;
				/* jshint ignore:end */
				ta.style.width = width;
			}

			ta.style.overflowY = value;
		}

		function getParentOverflows(el) {
			var arr = [];

			while (el && el.parentNode && el.parentNode instanceof Element) {
				if (el.parentNode.scrollTop) {
					arr.push({
						node: el.parentNode,
						scrollTop: el.parentNode.scrollTop
					});
				}
				el = el.parentNode;
			}

			return arr;
		}

		function resize() {
			if (ta.scrollHeight === 0) {
				// If the scrollHeight is 0, then the element probably has display:none or is detached from the DOM.
				return;
			}

			var overflows = getParentOverflows(ta);
			var docTop = document.documentElement && document.documentElement.scrollTop; // Needed for Mobile IE (ticket #240)

			ta.style.height = '';
			ta.style.height = ta.scrollHeight + heightOffset + 'px';

			// used to check if an update is actually necessary on window.resize
			clientWidth = ta.clientWidth;

			// prevents scroll-position jumping
			overflows.forEach(function (el) {
				el.node.scrollTop = el.scrollTop;
			});

			if (docTop) {
				document.documentElement.scrollTop = docTop;
			}
		}

		function update() {
			resize();

			var styleHeight = Math.round(parseFloat(ta.style.height));
			var computed = window.getComputedStyle(ta, null);

			// Using offsetHeight as a replacement for computed.height in IE, because IE does not account use of border-box
			var actualHeight = computed.boxSizing === 'content-box' ? Math.round(parseFloat(computed.height)) : ta.offsetHeight;

			// The actual height not matching the style height (set via the resize method) indicates that 
			// the max-height has been exceeded, in which case the overflow should be allowed.
			if (actualHeight < styleHeight) {
				if (computed.overflowY === 'hidden') {
					changeOverflow('scroll');
					resize();
					actualHeight = computed.boxSizing === 'content-box' ? Math.round(parseFloat(window.getComputedStyle(ta, null).height)) : ta.offsetHeight;
				}
			} else {
				// Normally keep overflow set to hidden, to avoid flash of scrollbar as the textarea expands.
				if (computed.overflowY !== 'hidden') {
					changeOverflow('hidden');
					resize();
					actualHeight = computed.boxSizing === 'content-box' ? Math.round(parseFloat(window.getComputedStyle(ta, null).height)) : ta.offsetHeight;
				}
			}

			if (cachedHeight !== actualHeight) {
				cachedHeight = actualHeight;
				var evt = createEvent('autosize:resized');
				try {
					ta.dispatchEvent(evt);
				} catch (err) {
					// Firefox will throw an error on dispatchEvent for a detached element
					// https://bugzilla.mozilla.org/show_bug.cgi?id=889376
				}
			}
		}

		var pageResize = function pageResize() {
			if (ta.clientWidth !== clientWidth) {
				update();
			}
		};

		var destroy = function (style) {
			window.removeEventListener('resize', pageResize, false);
			ta.removeEventListener('input', update, false);
			ta.removeEventListener('keyup', update, false);
			ta.removeEventListener('autosize:destroy', destroy, false);
			ta.removeEventListener('autosize:update', update, false);

			Object.keys(style).forEach(function (key) {
				ta.style[key] = style[key];
			});

			map.delete(ta);
		}.bind(ta, {
			height: ta.style.height,
			resize: ta.style.resize,
			overflowY: ta.style.overflowY,
			overflowX: ta.style.overflowX,
			wordWrap: ta.style.wordWrap
		});

		ta.addEventListener('autosize:destroy', destroy, false);

		// IE9 does not fire onpropertychange or oninput for deletions,
		// so binding to onkeyup to catch most of those events.
		// There is no way that I know of to detect something like 'cut' in IE9.
		if ('onpropertychange' in ta && 'oninput' in ta) {
			ta.addEventListener('keyup', update, false);
		}

		window.addEventListener('resize', pageResize, false);
		ta.addEventListener('input', update, false);
		ta.addEventListener('autosize:update', update, false);
		ta.style.overflowX = 'hidden';
		ta.style.wordWrap = 'break-word';

		map.set(ta, {
			destroy: destroy,
			update: update
		});

		init();
	}

	function destroy(ta) {
		var methods = map.get(ta);
		if (methods) {
			methods.destroy();
		}
	}

	function update(ta) {
		var methods = map.get(ta);
		if (methods) {
			methods.update();
		}
	}

	var autosize = null;

	// Do nothing in Node.js environment and IE8 (or lower)
	if (typeof window === 'undefined' || typeof window.getComputedStyle !== 'function') {
		autosize = function autosize(el) {
			return el;
		};
		autosize.destroy = function (el) {
			return el;
		};
		autosize.update = function (el) {
			return el;
		};
	} else {
		autosize = function autosize(el, options) {
			if (el) {
				Array.prototype.forEach.call(el.length ? el : [el], function (x) {
					return assign(x, options);
				});
			}
			return el;
		};
		autosize.destroy = function (el) {
			if (el) {
				Array.prototype.forEach.call(el.length ? el : [el], destroy);
			}
			return el;
		};
		autosize.update = function (el) {
			if (el) {
				Array.prototype.forEach.call(el.length ? el : [el], update);
			}
			return el;
		};
	}

	exports.default = autosize;
	module.exports = exports['default'];
});
});

var ClickToEditTextBox = /*#__PURE__*/function (_Component) {
  _inherits(ClickToEditTextBox, _Component);

  var _super = _createSuper(ClickToEditTextBox);

  function ClickToEditTextBox(props) {
    var _this;

    _classCallCheck(this, ClickToEditTextBox);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      if (prevProps.value !== _this.props.value) {
        _this.setState(_objectSpread2({}, _this.state, {
          textboxValue: _this.props.value
        }), function () {
          if (_this.isTextarea()) {
            autosize.update(_this.clickToEditTextbox);
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "escFunction", function (e) {
      if (e.keyCode === 27 && _this.state.showEdit) {
        _this.setState(_objectSpread2({}, _this.state, {
          textboxValue: _this.state.initialValue,
          showEdit: false
        }), function () {
          e.target.value = _this.state.initialValue;
          if (_this.props.onChange) _this.props.onChange(e);

          _this.clickToEditTextbox.blur();
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleBlur", function (e) {
      e.stopPropagation();
      e.preventDefault();

      _this.setState(_objectSpread2({}, _this.state, {
        showEdit: false
      }));

      if (_this.props.onBlur) _this.props.onBlur(e);
    });

    _defineProperty(_assertThisInitialized(_this), "handleClicked", function (e, shouldShow) {
      if (shouldShow === _this.state.showEdit) return;

      _this.setState(_objectSpread2({}, _this.state, {
        showEdit: shouldShow,
        initialValue: _this.props.value
      }));

      if (_this.props.onBlur) _this.props.onClick(e);
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (e) {
      if (e.target.value !== _this.state.textboxValue) {
        _this.setState(_objectSpread2({}, _this.state, {
          textboxValue: e.target.value
        }));

        if (_this.props.onChange) _this.props.onChange(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "isTextarea", function () {
      return _this.props.type !== "input";
    });

    _this.state = {
      textboxValue: _this.props.value,
      showEdit: false,
      initialValue: ""
    };
    return _this;
  }

  _createClass(ClickToEditTextBox, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener("keydown", this.escFunction, false);
      if (this.isTextarea()) autosize(this.clickToEditTextbox);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("keydown", this.escFunction, false);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React__default.createElement("div", {
        className: "click2edit-textbox__container ".concat(this.props.className || "")
      }, /*#__PURE__*/React__default.createElement(this.props.type, {
        ref: function ref(element) {
          return _this2.clickToEditTextbox = element;
        },
        className: "\n                            ".concat(this.props.hideBorder ? "click2edit-textbox__hideborder" : "", " \n                            ").concat(this.props.isLarge ? "click2edit-textbox__large" : "click2edit-textbox__std", "\n                        "),
        rows: this.props.rows,
        value: this.state.textboxValue,
        onChange: this.handleChange,
        placeholder: this.props.placeholder,
        type: this.props.type,
        onBlur: this.handleBlur,
        onFocus: this.props.onFocus,
        onClick: function onClick(e) {
          return _this2.handleClicked(e, true);
        }
      }), this.props.children);
    }
  }]);

  return ClickToEditTextBox;
}(React.Component);

_defineProperty(ClickToEditTextBox, "propTypes", {
  className: PropTypes__default.string,
  onChange: PropTypes__default.func,
  onBlur: PropTypes__default.func,
  onFocus: PropTypes__default.func,
  onClick: PropTypes__default.func,
  value: PropTypes__default.string,
  placeholder: PropTypes__default.string,
  type: PropTypes__default.oneOf(["textarea", "input"]),
  rows: PropTypes__default.number,
  isLarge: PropTypes__default.bool,
  children: PropTypes__default.oneOfType([PropTypes__default.node, PropTypes__default.string]),
  hideBorder: PropTypes__default.bool
});

_defineProperty(ClickToEditTextBox, "defaultProps", {
  type: "input",
  rows: 1,
  placeholder: "",
  value: "",
  textboxValue: "",
  hideBorder: false,
  onBlur: function onBlur() {
    return undefined;
  },
  onFocus: function onFocus() {
    return undefined;
  },
  onClick: function onClick() {
    return undefined;
  },
  onChange: function onChange() {
    return undefined;
  }
});



var measureElement = function measureElement(element) {
  var DOMNode = ReactDOM.findDOMNode(element);
  return {
    width: DOMNode.offsetWidth,
    height: DOMNode.offsetHeight
  };
};

Popover.propTypes = {
  showPopover: PropTypes__default.bool.isRequired,
  caretPosition: PropTypes__default.oneOf(["top-center", "top-right", "top-left", "bottom-center", "bottom-right", "bottom-left"]).isRequired,
  parent: PropTypes__default.object,
  // technically required but wont be populated right away because of the lifecycle
  zIndex: PropTypes__default.number,
  children: PropTypes__default.object.isRequired
};

function Popover(_ref) {
  var showPopover = _ref.showPopover,
      caretPosition = _ref.caretPosition,
      parent = _ref.parent,
      _ref$zIndex = _ref.zIndex,
      zIndex = _ref$zIndex === void 0 ? 666 : _ref$zIndex,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["showPopover", "caretPosition", "parent", "zIndex", "children"]);

  // The class "popover-container" needs to be applied to the element that you're clicking on.
  // This will make the button the anchor for the absolutely positioned popover to attach to.
  if (parent === null) return "";
  var parentHeight = measureElement(parent).height;
  var parentWidth = measureElement(parent).width;
  var calculatedBottomOffset = "".concat(parentHeight + 12, "px"); // the height of the parent + the arrow + padding

  var calculatedTopOffset = "".concat(parentHeight + 9, "px"); // the height of the parent + the arrow + padding

  var cornerArrowOffset = "".concat(parentWidth / 2 - 23, "px"); // the difference between half the parent size and the distance from the corner to the middle of the caret

  var style = {
    position: 'absolute',
    bottom: "auto",
    top: "auto",
    left: "auto",
    right: "auto",
    zIndex: zIndex
  };

  if (caretPosition === "bottom-left") {
    style.left = cornerArrowOffset;
    style.bottom = calculatedBottomOffset;
  }

  if (caretPosition === "bottom-center") {
    // shift half the popover content size and then shifted a little more to get to the middle of the parent
    style.transform = "translateX(calc(-50% + ".concat(parentWidth / 2, "px))");
    style.bottom = calculatedBottomOffset;
  }

  if (caretPosition === "bottom-right") {
    style.right = cornerArrowOffset;
    style.bottom = calculatedBottomOffset;
  }

  if (caretPosition === "top-left") {
    style.left = cornerArrowOffset;
    style.top = calculatedTopOffset;
  }

  if (caretPosition === "top-center") {
    // shift half the popover content size and then shifted a little more to get to the middle of the parent
    style.transform = "translateX(calc(-50% + ".concat(parentWidth / 2, "px))");
    style.top = calculatedTopOffset;
  }

  if (caretPosition === "top-right") {
    style.right = cornerArrowOffset;
    style.top = calculatedTopOffset;
  }

  var slideDirection = caretPosition.startsWith("top") ? "slide-down" : "slide-up";
  return /*#__PURE__*/React__default.createElement(reactTransitionGroup.CSSTransition, _extends({
    style: style,
    classNames: "popover--".concat(slideDirection),
    in: showPopover,
    timeout: 300,
    unmountOnExit: true
  }, rest), /*#__PURE__*/React__default.createElement("div", {
    className: "popover--".concat(caretPosition, " popover")
  }, children));
}



function MaskedValue(_ref) {
  var sensitiveValue = _ref.sensitiveValue,
      unmaskedLength = _ref.unmaskedLength;

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showSensitiveValue = _useState2[0],
      setShowSensitiveValue = _useState2[1];

  var maskedPortion = "".concat("*".repeat(sensitiveValue.length - unmaskedLength));
  var unmaskedPortion = "".concat(sensitiveValue.slice(unmaskedLength - unmaskedLength * 2, sensitiveValue.length));
  var eyecon = "".concat(settings.cdnUrlIcons, "/").concat(showSensitiveValue ? "hide" : "watchlist", ".svg");
  return /*#__PURE__*/React__default.createElement("span", {
    className: "masked-value"
  }, showSensitiveValue ? /*#__PURE__*/React__default.createElement("span", null, sensitiveValue) : /*#__PURE__*/React__default.createElement("span", null, "".concat(maskedPortion).concat(unmaskedPortion)), /*#__PURE__*/React__default.createElement(ReactSVG, {
    className: "eyecon",
    src: eyecon,
    onClick: function onClick() {
      return setShowSensitiveValue(!showSensitiveValue);
    }
  }));
}
MaskedValue.propTypes = {
  sensitiveValue: PropTypes__default.string.isRequired,
  unmaskedLength: PropTypes__default.number.isRequired
};



var SnackbarWithInlineButtons = function SnackbarWithInlineButtons(_ref) {
  var selectedItemCount = _ref.selectedItemCount,
      handleUnselectAll = _ref.handleUnselectAll,
      buttons = _ref.buttons,
      classNames = _ref.classNames;
  var isShown = selectedItemCount > 0;
  return isShown ? /*#__PURE__*/React__default.createElement("div", {
    className: "snackbar level" + (classNames || "")
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "level-left"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "level-item"
  }, selectedItemCount, " item(s) selected"), /*#__PURE__*/React__default.createElement("div", {
    className: "level-item"
  }, /*#__PURE__*/React__default.createElement(DefaultBtn, {
    className: "btn--base btn--inverse snackbar-btn",
    onClick: handleUnselectAll
  }, "UNSELECT ALL"))), /*#__PURE__*/React__default.createElement("div", {
    className: "level-right"
  }, buttons())) : "";
};

SnackbarWithInlineButtons.propTypes = {
  selectedItemCount: PropTypes.number.isRequired,
  handleUnselectAll: PropTypes.func.isRequired,
  buttons: PropTypes.func.isRequired,
  classNames: PropTypes.string
};



function CheckboxTreeMenu(_ref) {
  var items = _ref.items,
      searchPlaceholder = _ref.searchPlaceholder,
      updateSelectedItems = _ref.updateSelectedItems,
      _ref$hideSearch = _ref.hideSearch,
      hideSearch = _ref$hideSearch === void 0 ? false : _ref$hideSearch,
      _ref$noResultsText = _ref.noResultsText,
      noResultsText = _ref$noResultsText === void 0 ? "No results found" : _ref$noResultsText,
      rest = _objectWithoutProperties(_ref, ["items", "searchPlaceholder", "updateSelectedItems", "hideSearch", "noResultsText"]);

  // https://dowjones.github.io/react-dropdown-tree-select/#/story/readme
  // expects a specific data structure for the "items" parameter. You can find an example of that structure in CheckboxTreeMenuDemo.
  var findNode = function findNode(items, id) {
    // DropdownTreeSelect gives us an internal representation of the node
    // This finds the real one from the source data (with all it's children and grandchildren)
    var result = null;

    for (var i = 0; result == null && i < items.length; i++) {
      var item = items[i];

      if (item.id === id) {
        result = item;
      } else {
        if (item.children && item.children.length > 0) {
          result = findNode(item.children, id);
        }
      }
    }

    return result;
  };

  var getLeafNodes = function getLeafNodes(item) {
    if (item.children === undefined || item.children.length === 0) return [item];
    return _.flattenDeep(item.children.map(getLeafNodes));
  };

  var selectItems = function selectItems(currentNode, selectedNodes) {
    // Heads up: selectedNodes will consolidate the selected-ness as high up the tree as possible.
    // So if you have Parent A with Child A and Child B both selected then selectedNodes will contain a single element (Parent A).
    var selectedParentIds = selectedNodes.map(function (node) {
      return node._id;
    });

    var selectedLeaves = _.flattenDeep(selectedNodes.map(function (node) {
      var matchingItem = findNode(items, node.id);
      return _toConsumableArray(getLeafNodes(matchingItem));
    }));

    updateSelectedItems(selectedParentIds, selectedLeaves);
  };

  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: "checkbox-tree--container ".concat(hideSearch === true ? "hide-search" : "")
  }, rest), /*#__PURE__*/React__default.createElement(DropdownTreeSelect, {
    data: items,
    showDropdown: "always",
    onChange: selectItems,
    keepOpenOnSelect: true,
    showPartiallySelected: true,
    keepTreeOnSearch: true,
    keepChildrenOnSearch: true,
    texts: {
      placeholder: searchPlaceholder,
      noMatches: noResultsText
    }
  }));
}
CheckboxTreeMenu.propTypes = {
  items: PropTypes__default.arrayOf(PropTypes__default.shape({
    label: PropTypes__default.string,
    value: PropTypes__default.string,
    checked: PropTypes__default.bool,
    disabled: PropTypes__default.bool,
    expanded: PropTypes__default.bool,
    className: PropTypes__default.string,
    tagClassName: PropTypes__default.string,
    actions: PropTypes__default.array,
    dataset: PropTypes__default.object,
    isDefaultValue: PropTypes__default.bool,
    children: PropTypes__default.array
  })),
  searchPlaceholder: PropTypes__default.string,
  updateSelectedItems: PropTypes__default.func,
  hideSearch: PropTypes__default.bool,
  noResultsText: PropTypes__default.string
};

var lib = {
  AlertDialog: AlertDialog,
  DefaultButton: DefaultButton,
  DefaultBtn: DefaultBtn,
  DefaultModal: DefaultModal,
  SmallLoader: SmallLoader,
  LoadingPanel: LoadingPanel,
  NumberInput: NumberInput,
  SearchInput: SearchInput,
  ShowMore: ShowMore,
  TableActionBar: TableActionBar,
  TablePaginationBar: TablePaginationBar,
  Dropdown: Dropdown,
  SidePanel: SidePanel,
  measureWidth: measureWidth,
  RequiredInput: RequiredInput,
  Toggle: Toggle,
  ValidatedField: ValidatedField,
  Accordion: Accordion,
  TabbedPage: TabbedPage,
  RadioInput: RadioInput,
  EmptyState: EmptyState,
  CircleButton: CircleButton,
  ClickToEditTextBox: ClickToEditTextBox,
  Popover: Popover,
  MaskedValue: MaskedValue,
  SnackbarWithInlineButtons: SnackbarWithInlineButtons,
  CheckboxTreeMenu: CheckboxTreeMenu
};

module.exports = lib;
